import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {AngularJsMaterialModuleName, MaterialConfigurationsModuleName} from "../utils/names/requiredModulesNames";
import 'angular-material';

export const AngularMaterialConfigurationModuleConfiguration = new RestrictedRouteModuleConfiguration(
    MaterialConfigurationsModuleName,
    [MaterialConfigurationsModuleName, AngularJsMaterialModuleName],
    [],
    [],
    [],
    []
);